import { useState } from 'react';
import { connect } from 'react-redux';
import {
  changeProcRequestDisplay,
  changeProcRequestPopupWindow,
} from '../actions/procRequestAction';
import ProclamationTable from '../components/proclamation-request/ProclamationTable';
import ProcRequestsCalendar from '../components/proclamation-request/ProcRequestsCalendar';
import ProcRequestServicePopup from '../components/proclamation-request/ProcRequestServicePopup';
import tableStyles from '../styles/proclamation-request/ProclamationTable.module.scss';

const ProclamationRequestContainer = props => {
  const storageKey = 'procRequestSelectedMonth';
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [statuses, setStatuses] = useState({
    pending: true,
    approved: true,
    'in-progress': true,
    completed: true,
    delivered: true,
    withdrawn: true,
  });

  return (
    <div className='main-container'>
      <div
        style={{
          display: 'flex',
          flexDirection: window.innerWidth > 896 ? 'row' : 'column',
        }}>
        <div className='col flex-grow-1 p-0'>
          <ProcRequestsCalendar
            storageKey={storageKey}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            statuses={statuses}
            setStatuses={setStatuses}
          />
          <ProcRequestServicePopup
            selectedDay={selectedDate}
            shownStatuses={statuses}
          />
        </div>
        <div
          className={`col flex-grow-0 p-0 ${tableStyles['proc-list-container']}`}>
          <ProclamationTable
            changeProcRequestDisplay={props.changeProcRequestDisplay}
            changeProcRequestPopupWindow={props.changeProcRequestPopupWindow}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  changeProcRequestDisplay,
  changeProcRequestPopupWindow,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProclamationRequestContainer);
